import { REDUCER } from '../reducers/reducersConst';

let defaultCookiesState = {
  updatedMeetConsentCookie: null
};

export let cookies = (state = defaultCookiesState, action) => {
  switch (action.type) {
    case REDUCER.COOKIES.TOGGLE_MEET_COOKIE:
      return {
        ...state,
        updatedMeetConsentCookie: !state.updatedMeetConsentCookie
      };
    default:
      return state;
  }
};
